<template>
  <div class="sys-users-authorization-panel main-layout">
    <el-card class="box-outter">
      <c-title title="用户授权" :back="true"></c-title>
      <el-card class="box-auth" shadow="never">
        <div class="auth-container">
          <div class="role-list-container">
            <ul class="div-scroll">
              <li
                v-for="item in roleList"
                :key="item.id"
                @click="handleAddRole(item)"
              >
                {{ item.name }}({{ item.typeName }})
              </li>
            </ul>
          </div>
          <div class="user-role-container div-scroll">
            <ul>
              <li
                class="role-item"
                v-for="(role, index) in userRoleList"
                :key="role.id"
              >
                <el-input
                  :value="role.name + '(' + role.typeName + ')'"
                  readonly
                  class="role-input"
                ></el-input>
                <div class="button-input">
                  <el-input
                    :value="role.orgNameList.join()"
                    readonly
                    class="ellipsis"
                  >
                  </el-input>
                  <el-button type="primary" @click="handleSelectOrg(role)"
                    >请选择</el-button
                  >
                </div>
                <i
                  class="el-icon-remove"
                  @click="handleRemoveRole(index)"
                  title="移除"
                ></i>
              </li>
            </ul>
          </div>
        </div>
        <div class="btn-box">
          <el-button type="primary" @click="handleAuthorize">提交</el-button>
          <el-button @click="$router.go(-1)">取消</el-button>
        </div>
      </el-card>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      title="组织机构"
      :visible.sync="dialogFormVisible"
      @close="handleDialogClose"
      width="25%"
    >
      <div class="tree-container div-scroll" style="max-height: 500px">
        <el-tree
          :data="orgList"
          show-checkbox
          :default-expanded-keys="['#root']"
          node-key="id"
          ref="tree"
          highlight-current
          :check-strictly="true"
          :props="defaultProps"
        >
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleGetOrgList">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CTitle from "@/components/CTitle";
import { getNewArr } from "@/libs/tools";
import { mapState } from "vuex";
export default {
  components: {
    CTitle,
  },
  data() {
    return {
      roleId: "",
      roleList: [],
      userRoleList: [],
      userId: "",
      dialogFormVisible: false,
      orgList: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
  },
  created() {
    this.userId = this.$route.params.id;
    this.getRoleList();
    this.getUserRoleList(this.userId);
    this.getOrgList();
  },
  mounted() {},
  methods: {
    //   获取完整角色列表
    getRoleList() {
      this.$http
        .get("/account/sys/role/listAll")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.roleList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(`获取数据失败，${err}`);
        });
    },
    // 获取用户的角色列表
    getUserRoleList(id) {
      this.$http
        .get("/account/sys/user/getRoleOrgList", { params: { id } })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.userRoleList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(`获取数据失败，${err}`);
        });
    },
    // 获取组织机构树
    getOrgList() {
      this.$http.get("/account/sys/org/getOrgTree").then((res) => {
        if (res.code == this.SUCCESS_CODE) {
          this.orgList = res.data;
        }
      });
    },
    handleSelectOrg(role) {
      this.dialogFormVisible = true;
      this.roleId = role.id;
      // 回显所辖组织机构
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([]);
        if (role.orgIdList && role.orgIdList.length) {
          this.$refs.tree.setCheckedKeys(role.orgIdList);
        }
      });
    },
    handleDialogClose() {
      this.dialogFormVisible = false;
    },
    // 新增角色
    handleAddRole(item) {
      item.orgNameList = [];
      // 数组去重问题
      this.userRoleList = getNewArr(this.userRoleList, [item], "id");
    },
    // 获取用户管辖组织机构
    handleGetOrgList() {
      let idList = this.$refs.tree.getCheckedKeys();
      let orgList = this.$refs.tree.getCheckedNodes();
      console.log(orgList);
      let orgName = [];
      orgList.forEach((org) => {
        orgName.push(org.name);
      });

      this.userRoleList.forEach((item) => {
        if (item.id == this.roleId) {
          item.orgIdList = idList;
          item.orgNameList = orgName;
        }
      });
      this.dialogFormVisible = false;
    },
    // 完成用户授权
    handleAuthorize() {
      let sysAuthorizationDtoList = [];
      this.userRoleList.forEach((item) => {
        let dto = {
          id: item.id,
          idList: item.orgIdList,
        };
        sysAuthorizationDtoList.push(dto);
      });
      let params = {
        id: this.userId,
        sysAuthorizationDtoList,
      };
      // console.log(params)
      this.$http.post("/account/sys/user/authorization", params).then((res) => {
        console.log(res);
        if (res.code == this.SUCCESS_CODE) {
          this.$message({
            message: "恭喜你，授权成功！",
            type: "success",
          });
          this.$router.go(-1);
        }
      });
    },
    // 从角色列表中删除某个角色
    handleRemoveRole(index) {
      this.userRoleList.splice(index, 1);
    },
  },
};
</script>
